import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { BaseList } from '@app/shared/models/list';
import {BillingLog, SMPLog} from '@app/shared/models/log';


@Component({
    selector: 'billing-log-table',
    templateUrl: './billing-log-table.component.html',
    styleUrls: ['./billing-log-table.component.scss']
})
export class BillingLogTableComponent extends BaseComponent
                               implements OnInit {

    @Input()
    public logs: BaseList<BillingLog>;

    constructor() {
        super();
        this._idPrefix = 'billing-log-table.';
    }

    public ngOnInit() {
        super.ngOnInit();

    }

}
